var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          attrs: {
            title: _vm.title,
            "close-on-click-modal": false,
            visible: _vm.visible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "inputForm",
              class: _vm.method === "view" ? "readonly" : "",
              attrs: {
                model: _vm.inputForm,
                size: "small",
                disabled: _vm.method === "view",
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 15 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "父类id",
                            prop: "parentId",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写父类id" },
                            model: {
                              value: _vm.inputForm.parentId,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "parentId", $$v)
                              },
                              expression: "inputForm.parentId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "名称", prop: "name", rules: [] } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写名称" },
                            model: {
                              value: _vm.inputForm.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "name", $$v)
                              },
                              expression: "inputForm.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "英文名称",
                            prop: "nameEn",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写英文名称" },
                            model: {
                              value: _vm.inputForm.nameEn,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "nameEn", $$v)
                              },
                              expression: "inputForm.nameEn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "编号", prop: "code", rules: [] } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写编号" },
                            model: {
                              value: _vm.inputForm.code,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "code", $$v)
                              },
                              expression: "inputForm.code",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "是否删除",
                            prop: "isDeleted",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写是否删除" },
                            model: {
                              value: _vm.inputForm.isDeleted,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "isDeleted", $$v)
                              },
                              expression: "inputForm.isDeleted",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "项目版本",
                            prop: "projectVersionId",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写项目版本" },
                            model: {
                              value: _vm.inputForm.projectVersionId,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "projectVersionId", $$v)
                              },
                              expression: "inputForm.projectVersionId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _vm.method != "view"
                ? _c(
                    "el-button",
                    {
                      directives: [
                        { name: "noMoreClick", rawName: "v-noMoreClick" },
                      ],
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.doSubmit()
                        },
                      },
                    },
                    [_vm._v("确定")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }